// @vendors
const Immutable = require('immutable');

const INITIAL_STATE = Immutable.fromJS({
    hasSignaturePattern: true
});

function brokerConvenienceMiFIDTestStep4(state = INITIAL_STATE) {
    return state;
}

module.exports = brokerConvenienceMiFIDTestStep4;
